const CARDS = [
  {
    title: '《奥本海默》',
    meta: '剧情 / 传记 / 历史 · 2023',
    rating: '8.8',
    quality: '4K蓝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20style%20movie%20poster%20with%20dramatic%20black%20and%20white%20explosion%20mushroom%20cloud%2C%20intense%20expression%2C%20film%20grain%20texture%2C%20vintage%20scientific%20aesthetic%2C%20warm%20sepia%20undertones%2C%20high%20contrast&width=500&height=700&seq=card-oppenheimer&orientation=portrait',
    tag: '热门',
  },
  {
    title: '《繁花》',
    meta: '剧情 / 爱情 · 2024',
    rating: '8.7',
    quality: '超清',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%20nightlife%20in%201990s%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20elegant%20Chinese%20fashion%2C%20warm%20golden%20ambient%20lighting%2C%20nostalgic%20atmosphere%2C%20cinematic%20noir%20style&width=500&height=700&seq=card-fanhua&orientation=portrait',
    tag: '高分',
  },
  {
    title: '《海贼王》',
    meta: '动画 / 冒险 · 连载中',
    rating: '9.2',
    quality: '高清',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20pirate%20adventure%20anime%20illustration%20with%20ocean%20waves%20and%20golden%20sunset%2C%20dynamic%20character%20poses%2C%20vibrant%20warm%20color%20palette%2C%20cel%20shaded%20art%20style%2C%20cinematic%20composition&width=500&height=700&seq=card-onepiece&orientation=portrait',
    tag: '连载',
  },
  {
    title: '《狂飙》',
    meta: '剧情 / 犯罪 · 2023',
    rating: '8.5',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20drama%20aesthetic%20with%20dark%20alley%20and%20neon%20reflections%2C%20mysterious%20silhouette%2C%20rain%20soaked%20urban%20street%2C%20noir%20cinematography%20style%2C%20high%20contrast%20lighting%2C%20warm%20street%20lamp%20glow&width=500&height=700&seq=card-kuangbiao&orientation=portrait',
    tag: '热播',
  },
  {
    title: '《阿凡达：水之道》',
    meta: '科幻 / 冒险 · 2022',
    rating: '7.8',
    quality: '4K蓝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Alien%20ocean%20world%20with%20bioluminescent%20coral%20reefs%20and%20floating%20mountains%2C%20ethereal%20blue%20and%20teal%20underwater%20lighting%2C%20fantasy%20sci-fi%20atmosphere%2C%20cinematic%20wide%20vista%2C%20dreamlike%20quality&width=500&height=700&seq=card-avatar&orientation=portrait',
    tag: '视效',
  },
  {
    title: '《庆余年 第二季》',
    meta: '古装 / 权谋 · 2024',
    rating: '8.3',
    quality: '超清',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20intricate%20wooden%20carvings%20and%20silk%20fabrics%2C%20warm%20candlelight%20ambiance%2C%20traditional%20architecture%2C%20period%20drama%20aesthetic%2C%20rich%20golden%20and%20coral%20tones&width=500&height=700&seq=card-qingyu&orientation=portrait',
    tag: '热播',
  },
  {
    title: '《地球脉动 III》',
    meta: '纪录片 / 自然 · 2024',
    rating: '9.7',
    quality: '4K',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20nature%20landscape%20with%20diverse%20wildlife%20in%20golden%20hour%20light%2C%20savanna%20and%20mountains%2C%20documentary%20photography%20style%2C%20warm%20natural%20colors%2C%20majestic%20composition&width=500&height=700&seq=card-planet&orientation=portrait',
    tag: '神作',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">精选推荐</h2>
            <p className="mt-2 text-sm text-foreground-500">编辑精选高分佳作，品质观影从这里开始</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {CARDS.map((item, i) => (
              <a
                key={i}
                href="#media"
                className="group block"
              >
                <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-100 border border-background-200/60">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                  <div className="absolute top-2 left-2 flex items-center gap-1.5">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-primary-500 text-foreground-950">
                      {item.quality}
                    </span>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500/90 text-white">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="font-heading text-sm font-semibold text-white line-clamp-1">{item.title}</h3>
                    <p className="mt-1 text-xs text-foreground-200 line-clamp-1">{item.meta}</p>
                    <div className="mt-1.5 flex items-center gap-1">
                      <i className="ri-star-fill text-accent-400 text-xs"></i>
                      <span className="text-xs font-bold text-accent-400">{item.rating}</span>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}